var AbstractWS = require("./AbstractWS");

function ClearWS(parent) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.name = 'ClearWS' + this.parent.id;
  self.method('POST');


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/queue/' + self.parent.id + '/clear';
  });


	/**
	 * This method processes the data returned from the service
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {IssueWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    // Return self (ClearWS) to be chainable, for best practice
    return self;
  };

  return self;
};

ClearWS.prototype = AbstractWS.prototype;
ClearWS.prototype.constructor = ClearWS;

module.exports = ClearWS;
